import { render, staticRenderFns } from "./actuallyPaymentAmountConfig.vue?vue&type=template&id=9d12a2e8&scoped=true&"
import script from "./actuallyPaymentAmountConfig.vue?vue&type=script&lang=js&"
export * from "./actuallyPaymentAmountConfig.vue?vue&type=script&lang=js&"
import style0 from "./actuallyPaymentAmountConfig.vue?vue&type=style&index=0&id=9d12a2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d12a2e8",
  null
  
)

component.options.__file = "actuallyPaymentAmountConfig.vue"
export default component.exports